<template>
	<app-nav :value="drawer" @input="onNavInput" dark>
		<div>
			<img
				v-if="logo"
				:src="logo"
				alt="Logo"
				:height="logoHeight"
				:width="logoWidth"
				:style="logoStyle"
			/>
			<span v-if="title" class="primary--text">{{ title }}</span>
		</div>
		<template v-for="(item, i) in items">
			<app-nav-group
				v-if="item.items && ff(item) && can(item)"
				:key="`nav-${i}`"
				:icon="item.icon || null"
				:title="item.title || null"
			>
				<template v-for="(subitem, j) in item.items">
					<app-nav-item
						v-if="can(subitem)"
						:key="`nav-${i}-${j}`"
						:icon="subitem.icon || null"
						:title="subitem.title || null"
						:view="subitem.view || null"
						:exact="subitem.exact || false"
					/>
				</template>
			</app-nav-group>
			<app-nav-item
				v-else-if="!item.items && ff(item) && can(item)"
				:key="`nav-${i}`"
				:icon="item.icon || null"
				:title="item.title || null"
				:view="item.view || null"
				:exact="item.exact || false"
			/>
		</template>
	</app-nav>
</template>

<script>
import NavItem from '@/types/NavItem'

export default {
	props: {
		items: {
			type: Array,
			default: () => {},
			validator: arr => arr.every(el => el instanceof NavItem),
		},
		logo: String,
		title: String,
		logoStyle: String,
		logoWidth: [String, Number],
		logoHeight: [String, Number],
	},
	computed: {
		drawer() {
			return this.$store.getters['app/isNavOpen']
		},
	},
	methods: {
		onNavInput(value) {
			this.$store.dispatch('app/setNav', value)
		},
		check(item, field, pluginFn) {
			if (item.items && !item[field]) {
				const values = Object.keys(item.items.reduce((acc, subitem) => {
					if (!subitem[field]) { return acc }
					return {
						...acc,
						[subitem[field]]: true,
					}
				}, {}))

				return !values.length
					|| values.some(value => this.$ravello[pluginFn](value))
			}

			return !item[field] || this.$ravello[pluginFn](item[field])
		},
		ff(item) {
			return this.check(item, 'ff', 'ff')
		},
		can(item) {
			return this.check(item, 'permission', 'can')
		},
	},
}
</script>
